import { inject, Injectable } from "@angular/core";
import { AuthService, CheckoutService } from "@company-box/services";
import { HttpParams, HttpHeaders, HttpResponse } from "@angular/common/http";
import { AuthToken, User } from "@company-box/models";

@Injectable({
  providedIn: "root",
})
export class CBAuthService extends AuthService {

  private checkoutService = inject(CheckoutService);
  constructor() {
    super();
  }

  checkPassword(loginData: User): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const params = new HttpParams()
        .append("grant_type", "password")
        .append("username", loginData.username!)
        .append("password", loginData.password!);

      const oldToken = this.getToken();
      this.setToken(undefined);
      this.httpClient
        .post(`${this.environment.apiHost}/user/oauth/token`, params, {
          headers: new HttpHeaders({ "Content-type": "application/x-www-form-urlencoded; charset=utf-8" }),
        })
        .subscribe(
          (_res: any) => {
            this.setToken(oldToken);
            resolve(true);
          },
          (_response: HttpResponse<any>) => {
            this.setToken(oldToken);
            reject(false);
          }
        );
    });
  }

  override authorize(loginData: { username: any; password: any; firstName?: string; lastName?: string }): Promise<AuthToken> {
    return new Promise<AuthToken>((resolve, reject) => {
      this.setToken(undefined);

      const params = new HttpParams()
        .append("grant_type", "password")
        .append("username", loginData.username)
        .append("password", loginData.password);

      this.httpClient
        .post(`${this.environment.apiHost}/user/oauth/token`, params, {
          headers: new HttpHeaders({ "Content-type": "application/x-www-form-urlencoded; charset=utf-8" }),
        })
        .subscribe(
          (res: any) => {
            this.setToken(new AuthToken().deserialize(res));
            this.shopifyToken(loginData.username, loginData.password).then(
              (_shopifyToken) => {
                // this.logger.debug('New token', this._token);
                this.logger.debug("response success", res);
                this.update$.emit();
                this.checkToken().then(
                  (authenticated) => {
                    if (authenticated) {
                      resolve(this.getToken()!);
                    } else {
                      reject({ error: "invalid_grant", message: "Invalid username or password" });
                    }
                  },
                  (_response) => {
                    // console.log('response error', response);
                    this.logger.debug({ error: "session_expired", message: "Session Expired" });
                    reject({ error: "session_expired", message: "Session Expired" });
                  }
                );
              },
              (_error) => {
                reject({ error: "invalid_grant", message: "Invalid username or password" });
              }
            );
          },
          (_response: HttpResponse<any>) => {
            // console.log('response', response);
            reject({ error: "invalid_grant", message: "Invalid username or password" });
          }
        );
    });
  }

  override logout(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.httpClient.post(`${this.environment.apiHost}/user/logout`, null).subscribe(
        (_response: any) => {
          this.logger.info("User logged out");
          this.setToken(undefined);
          localStorage.clear();
          sessionStorage.clear();
          this.checkoutService.clear();
          this.update$.emit();
          resolve(true);
        },
        (error) => {
          console.log(error);
          this.logger.debug("Unable to log out user", error);
          reject(error);
        }
      );
    });
  }

  shopifyToken(username: any, password: any) {
    return new Promise<any>((resolve, reject) => {
      this.httpClient.post(`${this.environment.apiHost}/user/token`, { username, password }).subscribe(
        (res: any) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}
